////
/// ============================================================================
/// COMPONENT / Home Brands
/// ============================================================================
///
/// @group components
////

import GLightbox from "glightbox";

export default () => {
   GLightbox({
        selector: '.js-home-brands-popup'
    });
};
